<template>
  <div class="promo-design-group">
    <div class="video-play-option">
      <div class="upload-video-wrapper">
        <div v-if="isVideoUrl">
          <v-text-field
            v-model="videoUrl"
            variant="outlined"
            density="compact"
            label="Video Url"
            name="video-url"
            persistentPlaceholder
            hideDetails
          ></v-text-field>
        </div>
        <div v-else>
          <v-btn
            variant="flat"
            color="accent"
            class="upload-image-btn"
            @click="triggerUploadVideoInput"
          >
            <v-icon size="24" start>md:videocam</v-icon>Upload
            <span v-if="isMobile">mobile</span>video
          </v-btn>
          <input
            ref="uploadVideoInput"
            type="file"
            style="display: none"
            name="upload_video"
            accept="video/*"
            @change="uploadVideoInput"
          />
        </div>
        <div
          v-if="
            isMobile
              ? actions.rf_settings_mobile_video_filename && actions.rf_settings_mobile_video_src
              : actions.rf_settings_video_filename && actions.rf_settings_video_src
          "
          class="mb-3"
        >
          <span>Current File: </span>
          <span>{{
            isMobile
              ? actions.rf_settings_mobile_video_filename
              : actions.rf_settings_video_filename
          }}</span>
        </div>
        <div style="padding-top: 12px">
          <v-checkbox
            v-model="isUrl"
            label="Input video url"
            class="background-img-checkbox"
            trueValue="true"
            falseValue="false"
          />
        </div>
        <a v-if="videoHref" :href="videoHref" target="_blank">Open Video in New Tab </a>
        <div style="padding-top: 10px">
          <v-btn
            variant="flat"
            color="accent"
            class="upload-image-btn"
            @click="triggerUploadCoverImage"
          >
            <v-icon start>md:panorama</v-icon>Upload <span v-if="isMobile">mobile</span>video cover
          </v-btn>
          <input
            ref="bgImageInput"
            type="file"
            style="display: none"
            accept="image/*"
            @change="uploadCoverImage"
          />
        </div>
        <RfImageFileInfo
          :image="actions.rf_settings_bg_image"
          :filename="actions.rf_settings_bg_image_filename"
        />
        <div style="padding-left: 0" class="upload-img-helper">1920 x 1080px recommended</div>
      </div>
      <div class="div-flex-layout">
        <v-checkbox
          v-model="videoMuted"
          label="Mute video"
          trueValue="true"
          falseValue="false"
          class="background-img-checkbox"
          hideDetails
          @update:modelValue="onMutedChange"
        />
        <v-checkbox
          v-model="videoLooped"
          label="Loop video"
          trueValue="true"
          falseValue="false"
          class="background-img-checkbox"
          hideDetails
        />
      </div>
      <div class="div-flex-layout">
        <v-checkbox
          v-model="videoAutoplayed"
          label="Autoplay video"
          trueValue="true"
          falseValue="false"
          class="background-img-checkbox"
          hideDetails
          :disabled="autoplayDisabled"
        />
      </div>
      <div class="upload-img-helper pl-0!">
        Note: unmuted video cannot be autoplayed due to browser restrictions
      </div>
    </div>
  </div>
</template>

<script>
import { useLegacyLastErrorStore } from "@/pinia/legacyLastErrorStore";
import { usePromptStore } from "@/pinia/promptStore";
import { useToastsStore } from "@/pinia/toastsStore";
import RfImageFileInfo from "@/components/RfPathCreate/RfRetentionActions/components/RfImageFileInfo.vue";

export default {
  name: "RfRetentionVideoUpload",
  components: { RfImageFileInfo },
  props: ["actions", "model", "isMobile"],
  setup: () => ({
    toastsStore: useToastsStore(),
    promptStore: usePromptStore(),
    legacyLastErrorStore: useLegacyLastErrorStore(),
  }),
  data() {
    return {
      autoplayDisabled:
        (this.isMobile
          ? this.actions.rf_settings_mobile_video_muted
          : this.actions.rf_settings_video_muted) !== "true",
    };
  },
  computed: {
    videoMuted: {
      get() {
        return this.isMobile
          ? this.actions.rf_settings_mobile_video_muted
          : this.actions.rf_settings_video_muted;
      },
      set(value) {
        if (this.isMobile) {
          this.actions.rf_settings_mobile_video_muted = value;
        } else {
          this.actions.rf_settings_video_muted = value;
        }
      },
    },
    videoLooped: {
      get() {
        return this.isMobile
          ? this.actions.rf_settings_mobile_video_loop
          : this.actions.rf_settings_video_loop;
      },
      set(value) {
        if (this.isMobile) {
          this.actions.rf_settings_mobile_video_loop = value;
        } else {
          this.actions.rf_settings_video_loop = value;
        }
      },
    },
    videoAutoplayed: {
      get() {
        return this.isMobile
          ? this.actions.rf_settings_mobile_video_autoplayed
          : this.actions.rf_settings_video_autoplayed;
      },
      set(value) {
        if (this.isMobile) {
          this.actions.rf_settings_mobile_video_autoplayed = value;
        } else {
          this.actions.rf_settings_video_autoplayed = value;
        }
      },
    },
    videoHref() {
      return this.isMobile
        ? this.actions.rf_settings_mobile_video_src
        : this.actions.rf_settings_video_src;
    },
    videoUrl: {
      get() {
        return this.isMobile
          ? this.actions.rf_settings_mobile_video_src
          : this.actions.rf_settings_video_src;
      },
      set(value) {
        if (this.isMobile) {
          this.actions.rf_settings_mobile_video_src = value;
          const mediaType = value.split(".").pop();
          this.actions.rf_settings_mobile_video_media_type = mediaType;
        } else {
          this.actions.rf_settings_video_src = value;
          const mediaType = value.split(".").pop();
          this.actions.rf_settings_video_media_type = mediaType;
        }
      },
    },
    isUrl: {
      get() {
        return this.isMobile
          ? this.actions.rf_settings_mobile_video_is_url
          : this.actions.rf_settings_video_is_url;
      },
      set(value) {
        if (this.isMobile) {
          this.actions.rf_settings_mobile_video_is_url = value;
        } else {
          this.actions.rf_settings_video_is_url = value;
        }
      },
    },
    isVideoUrl() {
      const value = this.isMobile
        ? this.actions.rf_settings_mobile_video_is_url
        : this.actions.rf_settings_video_is_url;
      return ["true", true].includes(value);
    },
  },
  watch: {
    actions() {
      this.$emit("forceRender");
    },
  },
  methods: {
    triggerUploadVideoInput() {
      this.$refs.uploadVideoInput.click();
    },
    async uploadVideoInput() {
      this.legacyLastErrorStore.setLoading(true);

      const videoAttrs = await this.promptStore.getVideoUploadUrl({
        appId: this.$route.params.aid,
        pathId: this.$route.params.pid,
      });

      let uploadVideoUrl;
      let videoUrl;
      if (this.isMobile) {
        videoUrl = videoAttrs.rf_settings_mobile_video_src;
        uploadVideoUrl = videoAttrs.rf_settings_mobile_video_src_upload_url;
      } else {
        videoUrl = videoAttrs.rf_settings_video_src;
        uploadVideoUrl = videoAttrs.rf_settings_video_src_upload_url;
      }
      const file = this.$refs.uploadVideoInput.files[0];
      if (file.size > 5242880) {
        this.legacyLastErrorStore.setLoading(false);
        this.toastsStore.create({
          type: "error",
          body: "The 5 MB file size limit has been exceeded. Please upload a smaller file or specify a video URL.",
        });
        return;
      }
      const fileType = file.type;
      const filename = file.name;
      fetch(uploadVideoUrl, {
        method: "PUT",
        headers: {
          "Content-Type": fileType,
        },
        body: file,
      })
        .then(() => {
          this.legacyLastErrorStore.setLoading(false);
          const mediaType = fileType.split("/").pop();
          if (this.isMobile) {
            this.actions.rf_settings_mobile_video_media_type = mediaType;
            this.actions.rf_settings_mobile_video_filename = filename;
            this.actions.rf_settings_mobile_video_src = videoUrl;
          } else {
            this.actions.rf_settings_video_media_type = mediaType;
            this.actions.rf_settings_video_filename = filename;
            this.actions.rf_settings_video_src = videoUrl;
          }
          this.toastsStore.create({ type: "success", body: "Video was uploaded successfully." });
        })
        .catch(() => {
          this.legacyLastErrorStore.setLoading(false);
          this.toastsStore.create({
            type: "error",
            body: "Video upload failed. Please try again.",
          });
        });
    },
    triggerUploadCoverImage() {
      this.$refs.bgImageInput.click();
    },
    uploadCoverImage() {
      this.legacyLastErrorStore.setLoading(true);
      const reader = new FileReader();
      reader.addEventListener(
        "load",
        () => {
          this.actions.rf_settings_bg_image = reader.result;
          if (this.isMobile) {
            this.actions.rf_settings_mobile_video_poster = reader.result;
          } else {
            this.actions.rf_settings_video_poster = reader.result;
          }
          this.actions.rf_settings_video_poster = reader.result;

          this.$emit("forceRender");
          this.legacyLastErrorStore.setLoading(false);
        },
        false,
      );
      const inputRef = this.$refs.bgImageInput;
      const filepath = inputRef.files[0];
      if (filepath) {
        this.actions.rf_settings_bg_image_filename = filepath.name;
        reader.readAsDataURL(filepath);
      } else {
        this.legacyLastErrorStore.setLoading(false);
      }
    },
    onMutedChange(newValue) {
      this.autoplayDisabled = !newValue;
      if (!newValue) {
        if (this.isMobile) {
          this.actions.rf_settings_mobile_video_autoplayed = null;
        } else {
          this.actions.rf_settings_video_autoplayed = null;
        }
      }
    },
  },
};
</script>
<style scoped>
.upload-img-helper {
  text-align: center;
  padding: 10px 0 0 0;
}
.div-flex-layout {
  padding-top: 15px;
}
</style>
